import React from "react"
import { Route, Routes } from "react-router-dom"
import Layout from "./Layout"
import SignIn from "./pages/signin/SignIn"
import { Dashboard } from "./pages/dashboard/Dashboard"
import { Services } from "./pages/services/Services"
import { Inspirations } from "./pages/inspirations/Inspirations"
import ResetPassword from "./pages/signin/ResetPassword"
import Plan from "./pages/plan/plan"
import EmployeeRoleSetup from "./pages/employees/employeeRole"
import EmployeeList from "./pages/employees/employeeList"
import LeadAssignments from "./pages/leadManagement/LeadAssignments"
import LeadFollowUps from "./pages/leadManagement/LeadFollowUps"
import Leadanalytics from "./pages/leadManagement/Leadanalytics"
import Leadschedule from "./pages/leadManagement/Leadschedule"
import InspirationList from "./pages/datahub/inspiration/inspirationList"
import Product from "./pages/datahub/product/product"
import Smsmodule from "./pages/setting/smsmodule"
import ProductTemplates from "./pages/datahub/product/productTemplate"
import EmailModule from "./pages/setting/emailmodule"
import InspirationTemplates from "./pages/datahub/inspiration/inspirationTemplate"
import InspirationInactive from "./pages/datahub/inspiration/inspirationInactive"
import ProductInactive from "./pages/datahub/product/productInactive"
import NewEmployee from "./pages/employees/newemployee"
import CreateLead from './pages/leadManagement/CreateLead';
import LeadList from "./pages/leadManagement/Allleads"
import LeadDetails from "./pages/leadManagement/LeadDetails"
import ImportExportLeads from "./pages/leadManagement/ImportEx"
import { ServiceInactive } from "./pages/services/serviceInactive"
import { Alltemplate } from "./pages/showcase/Alltemplate"
import { Inactivetemplate } from "./pages/showcase/Inactivetemplate"
import { Whatsappmodule } from "./pages/setting/whatsappmodule"
import { QuoteTemplate } from "./pages/Quote/quoteTemplate"
import { QuoteInactive } from "./pages/Quote/quoteInactive"
import CreateQuote from "./pages/Quote/CreateQuote"
import QuoteViewDetails from "./pages/Quote/QuoteViewDetail"
import EditQuote from "./pages/Quote/EditQuote"
import InlineEditor from "./pages/showcase/Editor"
import { PageNotFound } from "./pages/Error/404"
import UnauthorizedPage from "./pages/Error/unauthorized"
import { Customerlist } from "./pages/customer/customerlist"
import { InactiveCustomerlist } from "./pages/customer/customerInactive"
import { Customerplan } from "./pages/customer/customerPlan"
import ExportCustomer from "./pages/customer/customerExport"
import CustomerDetailsPage from "./pages/customer/customerView"
import LeadTemplates from "./pages/b2bLead/b2bleadtemplate"
import LeadInactiveTemplates from "./pages/b2bLead/b2bInactiveLead"
import PrivateRoute from "./utils/PrivateRoute"
import InactiveEmployee from "./pages/employees/inactiveEmployee"
import CustomerCreation from "./pages/customer/customerCreate"
import AddData from "./pages/datahub/AddData"
import Datahubdashboard from "./pages/datahub/Datahubdashboard"
import AddProductTemplate from "./pages/datahub/product/AddProductTemplate"
import EmployeeDetails from "./pages/employees/employeedetail"
import TemplateDetails from "./pages/showcase/Templatedetails"
import ProfilePage from "./pages/profile/profile"
import AddInspirationTemplate from "./pages/datahub/inspiration/InspirationTemplateAdd"
import CreateB2bLead from "./pages/b2bLead/createB2bLead"
import B2bViewDetails from "./pages/b2bLead/b2bViewDetails"
import EditB2bLead from "./pages/b2bLead/editB2bLead"
import CreateService from "./pages/services/CreateService"
import EditService from "./pages/services/EditService"
import EditPlan from "./pages/plan/EditPlan"
import PlanDetails from "./pages/plan/planView"
import ViewService from "./pages/services/ViewService"
import CreateTem from "./pages/services/CreateTem"
import EditTem from "./pages/services/EditTem"
import TemViewDetails from "./pages/services/TemViewDetail"
import Chat from "./pages/chat/Chat"
import EmailTemplate from "./pages/emailTemplate/emailtemp"
import EmailEditor from "./pages/emailTemplate/emailEditor"
import EmailDetail from "./pages/emailTemplate/emailView"
import Apps from "./pages/CreateApp/Apps"
import AddApp from "./pages/CreateApp/newAddApp"
import PageBuilder from './pages/CreateApp/NavApp/PageBuilder';
import SchemaGen from './pages/CreateApp/NavApp/SchemaGen';
import WorkflowPage from './pages/CreateApp/NavApp/Workflow/workflow';
import { Roles } from "./pages/CreateApp/NavApp/RolesPermissions";
import { Deploy } from "./pages/CreateApp/NavApp/DeployTest";
import { dynamicMenus } from "./constants/AppMenu"
import AddWorkflow from "./pages/CreateApp/NavApp/Workflow/AddWorkFlow";



const RouteRoute = () => {
  return (
    <Routes>
      {/* Authentication Routes */}
      <Route path="/login" element={<SignIn />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />

      {/* Main Layout */}
      <Route path="/" element={<Layout />}>
        {/* Dashboard */}
        <Route
          index
          element={
            <PrivateRoute module="Dashboard" action="dashboard_get">
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* Explore Apps */}
        <Route path="explore">
        <Route index element={<Apps />} />
        </Route>

    

        {/* Services Routes */}
        <Route path="services">
          <Route index element={<Services />} />
          <Route path="addservice" element={<CreateService />} />
          <Route path="edit-service/:id" element={<EditService />} />
          <Route path="view-service/:id">
            <Route index element={<ViewService />} />
            <Route path="add-template" element={<CreateTem />} />
            <Route path="view-template/:id" element={<Chat />} />
            <Route path="edit-template/:id" element={<EditTem />} />
          </Route>
        </Route>

        {/* Employee Routes */}
        <Route path="rolesetup" element={<EmployeeRoleSetup />} />
        <Route path="employee">
          <Route index element={<EmployeeList />} />
          <Route path="addemployee" element={<NewEmployee />} />
          <Route path="editemployee/:id" element={<NewEmployee />} />
          <Route path="employeedetails/:id" element={<EmployeeDetails />} />
        </Route>
        <Route
          path="inactiveemployee"
          element={
            <PrivateRoute
              module="Employee Management"
              action="employee_inactive">
              <InactiveEmployee />
            </PrivateRoute>
          }
        />

        {/* Datahub Routes */}
        <Route path="datahub">
          <Route index element={<Datahubdashboard />} />
          <Route path="product" element={<Product />} />
          <Route path="create/data" element={<AddData />} />
          <Route path="inspiration" element={<Inspirations />} />
          <Route path="product/template" element={<ProductTemplates />} />
          <Route path="product/template/add" element={<AddProductTemplate />} />
          <Route
            path="inspiration/template"
            element={<InspirationTemplates />}
          />
          <Route
            path="inspiration/template/add"
            element={<AddInspirationTemplate />}
          />
        </Route>

        {/* Lead Management Routes */}
        <Route path="leads" element={<LeadList />} />
        <Route path="leadassigment" element={<LeadAssignments />} />
        <Route path="leadfollowups" element={<LeadFollowUps />} />
        <Route path="leadschedule" element={<Leadschedule />} />
        <Route path="leadanalytics" element={<Leadanalytics />} />
        <Route path="leadsexport" element={<ImportExportLeads />} />
        <Route path="lead">
          <Route path="create" element={<CreateLead />} />
          <Route path=":id" element={<LeadDetails />} />
        </Route>

        {/* Inactive Services */}
        <Route path="inactiveservices" element={<ServiceInactive />} />

        {/* Template & Chatbot Routes */}
        <Route path="templates" element={<Alltemplate />} />
        <Route path="inactivetemplates" element={<Inactivetemplate />} />
        <Route path="whatsappmodule" element={<Whatsappmodule />} />
        <Route path="chatbot" element={<Chat />} />

        {/* Quote Routes */}
        <Route path="quote">
          <Route index element={<QuoteTemplate />} />
          <Route path="add" element={<CreateQuote />} />
          <Route path=":id" element={<Chat />} />
          <Route path="edit/:id" element={<EditQuote />} />
        </Route>
        <Route path="inactivequote" element={<QuoteInactive />} />

        {/* Editor & Showcase Routes */}
        <Route path="show">
          <Route path="editor" element={<InlineEditor />} />
          <Route path="editor/:id" element={<InlineEditor />} />
          <Route path="template/:id" element={<TemplateDetails />} />
        </Route>

        {/* Customer Routes */}
        <Route path="customers">
          <Route index element={<Customerlist />} />
          <Route path="add" element={<CustomerCreation />} />
          <Route path="customerdetails/:id" element={<CustomerDetailsPage />} />
        </Route>
        <Route path="inactivecustomers" element={<InactiveCustomerlist />} />
        <Route path="customerplans" element={<Customerplan />} />
        <Route path="Createplans" element={<Plan />} />
        <Route path="customerplans/:id" element={<EditPlan />} />
        <Route path="customerview/:id" element={<PlanDetails />} />
        <Route path="customerreport" element={<ExportCustomer />} />
        <Route path="customer/edit" element={<CustomerDetailsPage />} />

        {/* B2B Lead Routes */}
        <Route path="leadtemplate">
          <Route index element={<LeadTemplates />} />
          <Route path="create" element={<CreateB2bLead />} />
          <Route path=":id" element={<B2bViewDetails />} />
          <Route path="edit/:id" element={<EditB2bLead />} />
        </Route>
        <Route path="leadinactive" element={<LeadInactiveTemplates />} />


        {/* EmailTemplate  */}
        <Route path="email" element={<EmailTemplate/>} />

        <Route path="email">
          <Route path="editor" element={<EmailEditor />} />
          <Route path="editor/:id" element={<EmailEditor />} />
          <Route path="template/:id" element={<TemplateDetails />} />
          <Route path="templateview/:id" element={< EmailDetail />} />

        </Route>

        {/* Settings & Modules */}
        <Route path="emailmodule" element={<EmailModule />} />
        <Route path="smsmodule" element={<Smsmodule />} />
        <Route path="setting" element={<ProfilePage />} />

        {/* Error Routes */}
        <Route path="unauthorized" element={<UnauthorizedPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>


      <Route
          path="/createApp"
          element={<Layout dynamicMenus={dynamicMenus} />}
        >
          <Route index={true} element={<AddApp/>}></Route>
          <Route path="schema" element={<SchemaGen/>}></Route>
          <Route path="pagebuilder" element={<PageBuilder/>}></Route>
          <Route path="workflow" element={<WorkflowPage/>}>

          </Route>
          <Route path="addWorkflow" element={<AddWorkflow />}></Route>

          <Route path="roles" element={<Roles/>}></Route>
          <Route path="deploy" element={<Deploy/>}></Route>
          <Route path="*" element={<PageNotFound />}></Route>

          {/* <Route path="/createApp/addWorkflow" element={<AddWorkflow />} ></Route> */}






          </Route>



          
    </Routes>
  );
};

export default RouteRoute;